import React, {useEffect, useState} from "react";
import { ChaptersData } from "../types";
const classnames = require('classnames')

interface VolumeProps {
    lists: Array<ChaptersData>,
    onChange: (active: number) => void,
    active?: number
}

const TimeHandle:React.FC<{ duration:number }> = ({duration}) => {
    duration = Math.ceil(duration / 60)
    if (duration / 1000 >= 60) {
        return duration % 60 === 0 ? <span>{duration / 60}小时</span> :
            <span>{Math.floor(duration / 60)}小时{duration % 60}分钟</span>
    } else {
        return <span>{duration}分钟</span>
    }
}

const Volume:React.FC<VolumeProps> = ({lists, onChange, active = 0}) => {



    return <div className="volume-lists">
        {
            lists.map((item, index) => {
                return <div
                    className={classnames('volume-item',{'active':active === index,'is-title':item.videoId === ""}) }
                    key={index}
                    onClick={() => onChange(index)}>

                    <div className="l">
                        <h3>{item.chapterName}</h3>
                    </div>

                    <div className="r">
                        {/*{*/}
                        {/*    <p className="iconfont" dangerouslySetInnerHTML={{ __html: vActive === index ? '&#xe606;' : '&#xe61c;' }}/>*/}
                        {/*}*/}
                        {
                            active === index ? <p className='play'>正在播放</p>  :  <p className="duration">
                                <TimeHandle duration={item.videoDuration}/>
                            </p>
                        }
                    </div>
                </div>
            })
        }
    </div>
}

export default Volume;
